class ColorPicker {
    constructor() {
        this.ajaxLock = false;
        this.loading = false;
        this.ableToPickColor = true;
        this.selectedProductColor = false;
        this.$ = jQuery;
        this.resultNumber = this.$('#color-picker .result').text();
        this.init();
        this.loadColors();

        this.searchQuery = {
            color: '',
            ncs: '',
        }

        nid_wc.productOptions = {}
    }

    init() {
        this.toggleColors();
    }

    /**
     * Method responsible for filter and search
     * 
     */
    loadColors() {
        let self = this;

        /**
         * Filter colors
         * 
         */
        this.$('#color-picker .palette-color').each(function () {
            self.$(this).on('click', function () {
                if (self.ableToPickColor) {
                    let tempResultNumber = 0;
                    self.$(this).toggleClass('is-active');

                    self.$('.color-info').css('display', 'none')

                    if (self.$(this).hasClass('is-active')) {
                        self.$(this).siblings().removeClass('is-active');
                        let termId = self.$(this).data('termid');

                        self.$('#color-picker article.color').each(function () {
                            self.$(this).hide();
                        });

                        self.$('#color-picker article.color').each(function () {
                            let currentTermId = self.$(this).data('termid');

                            if (termId == currentTermId) {
                                tempResultNumber++;
                                self.$(this).show();
                            }
                        });

                        self.$('#color-picker .result').text(`${tempResultNumber} kulörer`);
                    } else {
                        self.$('#color-picker article.color').each(function () {
                            self.$(this).show();
                        });
                        self.$('#color-picker .result').text(`${self.resultNumber}`);
                    }
                }

            });
        });

        /**
         * Handle white color selections
         */

        this.$('.radio-swatches #radio-white').change(function(e) {
            e.preventDefault();

            if (!$(this).is(':checked')) 
                return

            self.$(this).selectedProductColor = false;
            self.$('#colorPickerModal .selected-color').text('');  
        })

        /**
         * Display search form
         * 
         */
                this.$('#color-picker .display-color-search').each(function () {
                    self.$(this).on('click', function () {
                        // Hide others
                        self.$('.color-filter-wrapper').fadeOut();
                        self.$('.color-search-trigger').removeClass('is-hidden');
                        
                        // Reset color filter
                        self.ableToPickColor = false;
                        self.$('#color-picker .palette-color').each(function () {
                            self.$(this).removeClass('is-active');
                        });
                        self.$('#color-picker article.color').each(function () {
                            self.$(this).show();
                        });
                        self.$('#color-picker .result').text(`${self.resultNumber}`);
        
                        if (!self.$(this).hasClass('is-hidden')) {
                            self.$(this).addClass('is-hidden')
        
                            console.log('cc')
                            // Trigger only on mobile devices
                            if (576 < self.$(window).width()) {
                                self.$('.search-color-wrapper')
                                    .css({
                                        "display": "flex",
                                    })
                                    .hide()
                                    .fadeIn(100);

                                    self.$('#color-picker-search').fadeIn().css({
                                        "display": "flex",
                                    })
                            } else {
                                self.$('.search-color-wrapper')
                                    .css({
                                        "display": "flex",
                                    })
                                    .hide()
                                    .slideToggle(100);

                                    self.$('#color-picker-search').fadeIn().css({
                                        "display": "flex",
                                    })
                            }
                        }
                    });
                })

                
        /**
         * Display search form
         * 
         */
        this.$('#color-picker .display-color-ncs-search').each(function () {
            self.$(this).on('click', function () {
                // Hide others
                self.$('.color-filter-wrapper').fadeOut();
                self.$('.color-search-trigger').removeClass('is-hidden');

                // Reset color filter
                // self.ableToPickColor = false;
                // self.$('#color-picker .palette-color').each(function () {
                //     self.$(this).removeClass('is-active');
                // });
                // self.$('#color-picker article.color').each(function () {
                //     self.$(this).show();
                // });
                // self.$('#color-picker .result').text(`${self.resultNumber}`);

                if (!self.$(this).hasClass('is-hidden')) {
                    self.$(this).addClass('is-hidden')

                    // Trigger only on mobile devices
                    if (576 < self.$(window).width()) {
                        self.$('.search-color-ncs-wrapper')
                            .css({
                                "display": "flex",
                            })
                            .hide()
                            .fadeIn(100);

                            self.$('#color-picker-ncs-search').fadeIn().css({
                                "display": "flex",
                            })
                    } else {
                        self.$('.search-color-ncs-wrapper')
                            .css({
                                "display": "flex",
                            })
                            .hide()
                            .slideToggle(100);

                            self.$('#color-picker-ncs-search').fadeIn().css({
                                "display": "flex",
                            })
                    }
                }
            });
        })

        /**
         * Hide search forms
         * 
         */
        this.$('#color-picker #color-picker-search .post-input').on('click', function () {
            // Reset input
            self.$('#color-picker #color-picker-search .color-picker-search-input').val('');
            self.$('#color-picker .color-wrapper').empty();

            self.spinner = true;
            if (self.spinner && !self.$('#color-picker .loading-search-result').hasClass('is-active')) {
                self.$('#color-picker .loading-search-result').addClass('is-active');
            }

            // Toggle search
            self.$('.search-color-wrapper').fadeOut();
            self.$('.display-color-search').removeClass('is-hidden');

            // Reset
            self.searchQuery.color = '';

            if(self.searchQuery.ncs != '') {
                self.$('#color-picker #color-picker-ncs-search').submit();
            } else {
                // Get all colors again
                self.ajaxResetRenderer();
            }
        });

        this.$('#color-picker #color-picker-ncs-search .post-input').on('click', function () {
            // Reset input
            self.$('#color-picker #color-picker-ncs-search .color-picker-search-input').val('');
            self.$('#color-picker .color-wrapper').empty();

            self.spinner = true;
            if (self.spinner && !self.$('#color-picker .loading-search-result').hasClass('is-active')) {
                self.$('#color-picker .loading-search-result').addClass('is-active');
            }

            // Reset
            self.searchQuery.ncs = '';

            // Toggle search
            self.$('.search-color-ncs-wrapper').fadeOut();
            self.$('.display-color-ncs-search').removeClass('is-hidden').fadeIn()

            if(self.searchQuery.color != '') {
                self.$('#color-picker #color-picker-search').submit();
            } else {
                // Get all colors again
                self.ajaxResetRenderer();
            }
        });

        /**
         * Handla search input
         * 
         */
        this.$('#color-picker #color-picker-search').submit(function (e) {
            e.preventDefault();

            self.$('#color-picker .color-wrapper').empty();

            let s = self.$(this).children('.color-picker-search-input').val();
            let nonce = self.$(this).children('.color-picker-search-input').data('nonce');

            self.spinner = true;
            if (self.spinner && !self.$('#color-picker .loading-search-result').hasClass('is-active')) {
                self.$('#color-picker .loading-search-result').addClass('is-active');
            }

            self.searchQuery.color = s;
            self.ajaxSearchRenderer(s, nonce, 'color');
        });

        this.$('#color-picker #color-picker-ncs-search').submit(function (e) {
            e.preventDefault();

            self.$('#color-picker .color-wrapper').empty();

            let s = self.$(this).children('.color-picker-search-input').val();
            let nonce = self.$(this).children('.color-picker-search-input').data('nonce');

            self.spinner = true;
            if (self.spinner && !self.$('#color-picker .loading-search-result').hasClass('is-active')) {
                self.$('#color-picker .loading-search-result').addClass('is-active');
            }

            console.log('searching ncs');
            self.searchQuery.ncs = s;
            self.ajaxSearchRenderer(s, nonce, 'ncs');
        });
    }

    /**
     * Method responsible for displaying more information on each color
     * 
     */
    toggleColors() {
        let self = this;

        this.$('#color-picker .color-wrapper .color').each(function () {
            self.$(this).on('click', function () {
                var toggleStatus = self.$(this).hasClass('expanded');

                self.$('#color-picker .color-wrapper .color').removeClass('expanded');

                // Trigger only on mobile devices
                if (576 > self.$(window).width()) {
                    self.$(this).toggleClass('is-active');
                }

                if(toggleStatus) {
                    self.$(this).removeClass('expanded');

                    self.selectedProductColor = false;
                    nid_wc.productOptions.color = false;
                    self.$('.radio-swatches .selected-color').text('');
                } else {
                    self.$(this).addClass('expanded');

                    nid_wc.productOptions = {
                        color: {
                            id: self.$(this).data('termid'),
                            style: self.$(this).attr('style'),
                            name: self.$(this).find('.name').text()
                        }
                    };

                    self.selectedProductColor = nid_wc.productOptions.color;
                    self.$('.radio-swatches .selected-color').text(nid_wc.productOptions.color.name);
                }

                let id = self.$(this).attr('id');

                // console.log('testklick');

                self.$(`#color-picker .color-wrapper .color-info[data-id='${id}']`).slideToggle(100);
            });
        });

        this.$('#color-picker .color-wrapper .close').each(function () {
            self.$(this).on('click', function () {
                let id = self.$(this).parent().parent().data('id').toString();

                if (576 > self.$(window).width()) {
                    self.$(`#color-picker .color-wrapper .color#${id}`).toggleClass('is-active');
                }

                self.$(this).parent().parent().slideToggle(100);
            });
        });
    }


    /**
     * Display all colors for "Kulörväljaren"
     * 
     */
    ajaxResetRenderer() {
        let self = this;
        this.ajaxLock = true;

        this.$.ajax({
            method: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'json',
            data: {
                action: 'mm_load_reset',
            },
        })
            .done(function (response) {
                self.$('#color-picker .color-wrapper').empty();
                self.$('#color-picker .color-wrapper').append(response.content);
                self.$('#color-picker .color-wrapper').fadeIn();
                self.$('#color-picker .result').text(`${self.resultNumber}`);

                self.init();

                self.loading = false;
                if (!self.loading && self.$('#color-picker .loading-search-result').hasClass('is-active')) {
                    self.$('#color-picker .loading-search-result').removeClass('is-active');
                }

                self.ableToPickColor = true;
                self.$('#color-picker .display-color-search').each(function () {
                    if (self.$(this).hasClass('is-hidden')) {
                        self.$(this).removeClass('is-hidden');

                        // Trigger only on mobile devices
                        if (576 < self.$(window).width()) {
                            self.$('#color-picker-search')
                                .fadeOut(100);
                        } else {
                            self.$('#color-picker-search').slideToggle(100);
                        }
                    }
                });

                this.ajaxLock = false;
                console.log('Success');
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                this.ajaxLock = false;

                console.log(XMLHttpRequest);
                console.log(textStatus);
                console.log(errorThrown);

                console.log('Failed');
            });
    }

    /**
     * Display colors for "Kulörväljaren", based on search term
     * 
     * @param {string} s 
     * @param {string} nonce 
     */
    ajaxSearchRenderer(s, nonce, type) {
        let self = this;
        this.ajaxLock = true;

        this.$.ajax({
            method: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'json',
            data: {
                action: 'mm_load_color_search',
                s: s,
                type: type,
                nonce: nonce,
            },
        })
            .done(function (response) {
                self.$('#color-picker .color-wrapper').empty();
                self.$('#color-picker .color-wrapper').fadeIn();
                self.$('#color-picker .color-wrapper').append(response.content);
                self.$('#color-picker .result').text(`${response.colors}`);

                console.log(response.content)
                self.init();

                console.log('Success');
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                this.ajaxLock = false;

                console.log(XMLHttpRequest);
                console.log(textStatus);
                console.log(errorThrown);

                console.log('Failed');
            }).always(function () {
                console.log('done')
                self.loading = false;
                if (!self.loading && self.$('#color-picker .loading-search-result').hasClass('is-active')) {
                    self.$('#color-picker .loading-search-result').removeClass('is-active');
                }

                this.ajaxLock = false;
            });
    }
}

export default ColorPicker;